import { z } from 'zod'
import { ChangeId, ObjectId, OperationTypeId } from './common-schemas'
import { GarItem } from './gar-item'

export namespace ChangeHistoryItem {
  export interface Data {
    /** @description Identifier of the changing transaction */
    readonly changeId: number

    /** @description Global unique identifier of the address object */
    readonly objectId: number

    /** @description Global unique identifier of the changing transaction ID */
    readonly addrObjectId: string

    /** @description Action status ID */
    readonly operationTypeId: number

    /** @description Regulatory document identifier */
    readonly nDocId?: number

    /** @description Change date */
    readonly changeDate: Date
  }
}

/** @description Information about change history event */
export class ChangeHistoryItem extends GarItem<
  'ChangeHistoryItem',
  ChangeHistoryItem.Data
> {
  static readonly SCHEMA: GarItem.Schema<ChangeHistoryItem.Data> = z
    .strictObject({
      CHANGEID: ChangeId,

      OBJECTID: ObjectId,

      ADROBJECTID: z
        .string()
        .describe('Global unique identifier of the changing transaction ID'),

      OPERTYPEID: OperationTypeId,

      NDOCID: z.coerce
        .number<string>()
        .int()
        .describe('Regulatory document identifier')
        .optional(),

      CHANGEDATE: z.coerce.date<string>().describe('Change date'),
    })
    .transform<ChangeHistoryItem.Data>(attributes => ({
      changeId: attributes.CHANGEID,
      objectId: attributes.OBJECTID,
      addrObjectId: attributes.ADROBJECTID,
      operationTypeId: attributes.OPERTYPEID,
      nDocId: attributes.NDOCID,
      changeDate: attributes.CHANGEDATE,
    }))

  readonly type = 'ChangeHistoryItem'

  protected get schema() {
    return ChangeHistoryItem.SCHEMA
  }
}
